export default "__VITE_ASSET__C$Rbhkv$__"